import StoresLocator from "./components/StoresLocator.jsx";

const { createRoot, createElement } = wp.element;

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".manitoba-stores-locator").forEach((el) => {
    const root = createRoot(el);
    root.render(
      createElement(StoresLocator, {
        googleMapsApiKey: el.getAttribute("data-googlemaps-apikey"),
        countries: el.getAttribute("data-countries"),
      })
    );
  });
});
